import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, MenuItem, TableRow, Table, TableHead, TableBody, TableContainer, Paper, TableCell, Card, Box, Typography, IconButton, FormHelperText, Tooltip, TextField, InputAdornment, LinearProgress, CircularProgress } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import RefreshIcon from '@material-ui/icons/Refresh';
import FilterListIcon from '@material-ui/icons/FilterList';
import SearchIcon from '@material-ui/icons/Search';
import ImageIcon from '@material-ui/icons/Image';
import VideocamIcon from '@material-ui/icons/Videocam';
import { getDashboardPageStyles } from "../../utils/dashboardPageStyles";
import SchoolIcon from '@material-ui/icons/School';

import ActivityTabelService from "./Locality/Service/activityTabelService";
import SubActivityService from "./Locality/Service/subActivityService";
import ImagesStoreService from "./Locality/Service/imagesStoreService";
import * as Yup from 'yup';
import TablePagination from '@material-ui/core/TablePagination';
import { Grid, Select, Chip } from "@material-ui/core";
import { useFormik } from 'formik';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { makeStyles } from '@material-ui/core/styles';
import AddClassService from "./Locality/Service/addClassService";
import SuperActivityService from "./Locality/Service/superActivityService";
import { canEditDeleteActivityRow } from "../../utils/activityRowPermissions";
import { buildListSchoolRequest, buildCatalogListBody, effectiveSchoolIdForWrite, filterRowsBySchoolScope, getUserDetails, resolveRowSchoolId, resolveSchoolId, resolveSchoolIdForClass, resolveRowSchoolLabel, resolveSchoolLabel, resolveCatalogFormSchooleId, resolveCatalogWriteSchooleId, normalizeId, isSchoolAddedRow, shouldShowSchoolColumn, dedupeSuperActivitiesForFilter, filterRowsBySuperActivity, filterRowsByClassId, filterRowsByCatalogType, parseCatalogListResponse, SUPER_ACTIVITY_DROPDOWN_FIELDS } from "../../utils/activityCatalogScope";

const MAX_ACTIVITY_IMAGES = 10;
const MAX_ACTIVITY_VIDEOS = 5;
const MAX_VIDEO_SIZE_MB = 200;
const MAX_VIDEO_BYTES = MAX_VIDEO_SIZE_MB * 1024 * 1024;
const CONTENT_EXCLUSIVE_HINT =
    'Notes, images and videos can be set on either List of Activities or Exercises, not both.';

const hasCatalogContent = (row) => {
    if (!row) return false;
    if (String(row.notes || '').trim()) return true;
    if (Array.isArray(row.imageURL) && row.imageURL.filter(Boolean).length) return true;
    if (Array.isArray(row.videoURL) && row.videoURL.filter(Boolean).length) return true;
    return false;
};
const useStyles = makeStyles((theme) => ({
    ...getDashboardPageStyles(theme),
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    dialogPaper: {
        borderRadius: 14,
        width: 520,
        maxWidth: '95vw',
    },
    dialogTitleBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 2.5),
        borderBottom: '1px solid #eef1f5',
    },
    dialogTitleText: {
        fontWeight: 700,
        fontSize: '1.15rem',
        color: '#0f2d4d',
    },
    dialogBody: {
        padding: theme.spacing(2.5),
    },
    fieldLabel: {
        display: 'block',
        fontSize: '0.78rem',
        fontWeight: 600,
        color: '#46566b',
        marginBottom: 6,
    },
    dialogFooter: {
        padding: theme.spacing(1.5, 2.5),
        borderTop: '1px solid #eef1f5',
    },
    cancelBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        color: '#46566b',
    },
    saveBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        backgroundColor: '#1769d6',
        color: '#fff',
        boxShadow: '0 4px 10px rgba(23,105,214,0.25)',
        '&:hover': { backgroundColor: '#125bbd' },
        '&:disabled': { color: '#fff', opacity: 0.65 },
    },
    mediaHint: {
        fontSize: '0.72rem',
        color: '#7a8aa0',
        marginBottom: 8,
    },
    exclusiveWarnBox: {
        marginBottom: 12,
        padding: '10px 12px',
        borderRadius: 10,
        backgroundColor: '#fff8e6',
        border: '1px solid #ffe4a3',
    },
    exclusiveWarnText: {
        color: '#7a5c00',
        fontSize: '0.8rem',
        lineHeight: 1.5,
    },
    mediaActions: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 8,
        marginBottom: 10,
    },
    mediaPickBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        borderColor: '#1769d6',
        color: '#1769d6',
    },
    mediaPreviewGrid: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 10,
    },
    mediaPreviewItem: {
        position: 'relative',
        width: 88,
    },
    mediaThumb: {
        width: 88,
        height: 88,
        objectFit: 'cover',
        borderRadius: 8,
        border: '1px solid #e6eaf0',
        display: 'block',
        backgroundColor: '#f8fafc',
    },
    mediaVideoTile: {
        width: 88,
        height: 88,
        borderRadius: 8,
        border: '1px solid #e6eaf0',
        backgroundColor: '#0f2d4d',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
    },
    mediaRemoveBtn: {
        position: 'absolute',
        top: 2,
        right: 2,
        backgroundColor: 'rgba(255,255,255,0.95)',
        padding: 3,
        '&:hover': { backgroundColor: '#fff' },
    },
    uploadProgressWrap: {
        marginTop: 8,
        marginBottom: 4,
    },
    emptyFilterBox: {
        marginTop: 12,
        padding: '10px 14px',
        borderRadius: 10,
        backgroundColor: '#fff8e6',
        border: '1px solid #ffe4a3',
    },
    emptyFilterText: {
        color: '#7a5c00',
        fontSize: '0.875rem',
        lineHeight: 1.55,
    },
    placeholderText: {
        color: '#94a3b8',
        fontStyle: 'italic',
        fontSize: '0.875rem',
    },
}));
export default function Activity({ embedded = false, scope = null, sharedClassList = null, sharedSchoolList = null, active = true }) {
    const tableHeaders = ['Class', 'Area Of Work', 'List Of Activities', 'Add More', 'Actions'];
    const classes = useStyles();
    const userDetails = useMemo(
        () => scope?.userDetails || getUserDetails(),
        [scope]
    );
    const useExternalScope = embedded && scope != null;
    const serverPaginated = useExternalScope;
    const scopeSchoolId = scope?.filterSchoolId ?? '';
    const scopeClassId = scope?.filterClassId ?? '';
    const scopeCatalogType = scope?.catalogType || 'indian';
    const [filterExercise, setExercise] = useState('');
    const [filterActivityList, setFilterActivityList] = useState([]);
    const [filterActivity, setActivity] = useState('');
    const [filterExerciseList, setExerciseList] = useState([]);
    const [temActivitylList, setTempActivityList] = useState([]);
    const [tabelList, setTabelList] = useState([]);
    const [filterSuperActivity, setfilterSuperActivity] = useState('');
    const [filterClassId, setFilterClassId] = useState('');
    const [classNameList, setClassNameList] = useState([]);
    const [activitylList, setActivityList] = useState([]);
    const [addClassList, setAddClassList] = useState([]);
    const [addSchoolList, setAddSchoolList] = useState([]);
    // SUPERADMIN can explicitly pick which school a list activity belongs to
    // (in the Add/Edit dialog) instead of relying only on the top scope filter.
    const isSuperAdminScope = Boolean(useExternalScope && scope?.isSuperAdmin);
    const [superActivityList, setSuperActivityList] = useState([]);
    const [age, setAge] = React.useState('');
    var [error, setError] = useState(null);
    const [tabelIdList, setTabelIdList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [pendingDelete, setPendingDelete] = useState(null);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(embedded ? 10 : 1000);
    const [listTotal, setListTotal] = useState(0);
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [addSuperActivityList, setAddSuperActivityList] = useState([]);
    const [tabel, setTabel] = useState({
        classId: '',
        superActivityId: '',
        activityName: '',
        notes: '',
        imageURL: [],
        videoURL: [],
        schooleId: '',
        catalogType: scopeCatalogType,
    });
    const [viewOpen, setViewOpen] = useState(false);
    const [viewRow, setViewRow] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [mediaUploading, setMediaUploading] = useState(false);
    const [mediaUploadProgress, setMediaUploadProgress] = useState({ percent: 0, message: '' });
    const [exerciseHasContent, setExerciseHasContent] = useState(false);
    const imageInputRef = useRef(null);
    const videoInputRef = useRef(null);
    
    const validationSchema = Yup.object().shape({
        // classId: Yup.string().required('Class Name is required'),
        superActivityId: Yup.string().required('super Activity Name is required'),
        activityName: Yup.string().required('Activity Name is required'),

    });
    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    }
    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }

    useEffect(() => {
        const timer = setTimeout(() => setDebouncedSearch(searchTerm), 400);
        return () => clearTimeout(timer);
    }, [searchTerm]);

    useEffect(() => {
        if (!serverPaginated) return;
        setpg(0);
    }, [debouncedSearch, scopeSchoolId, scopeClassId, scopeCatalogType, filterSuperActivity, serverPaginated]);
    const loadSuperActivitiesForClass = useCallback((classId) => {
        const { listId, role } = buildListSchoolRequest(
            userDetails,
            useExternalScope ? scopeSchoolId : resolveSchoolId(userDetails)
        );
        if (!listId) {
            setAddSuperActivityList([]);
            return;
        }
        const applyAreas = (res) => {
            let rows = filterRowsBySchoolScope(
                Array.isArray(res) ? res : [],
                useExternalScope ? scopeSchoolId : '',
                useExternalScope ? scopeCatalogType : undefined
            );
            if (useExternalScope) {
                rows = filterRowsByCatalogType(rows, scopeCatalogType);
            }
            setAddSuperActivityList(
                classId ? rows : dedupeSuperActivitiesForFilter(rows)
            );
        };
        const listBody = useExternalScope
            ? buildCatalogListBody(listId, {
                classId: classId || scopeClassId || '',
                catalogType: scopeCatalogType,
              })
            : {};
        const dropdownFields = { fields: SUPER_ACTIVITY_DROPDOWN_FIELDS };
        if (classId) {
            SuperActivityService.getAllSuperActivityById(
                listId,
                { ...listBody, classId },
                role,
                dropdownFields
            )
                .then(applyAreas)
                .catch(() => setAddSuperActivityList([]));
            return;
        }
        SuperActivityService.getAllSuperActivity(listId, role, listBody, dropdownFields)
            .then(applyAreas)
            .catch(() => setAddSuperActivityList([]));
    }, [userDetails, useExternalScope, scopeSchoolId, scopeClassId, scopeCatalogType]);

    const effectiveClassFilter = useExternalScope ? scopeClassId : filterClassId;

    useEffect(() => {
        if (!useExternalScope) return;
        setfilterSuperActivity('');
        setpg(0);
    }, [scopeSchoolId, scopeClassId, useExternalScope]);

    const applySchoolScopedRows = useCallback((rows) => {
        return filterRowsBySchoolScope(
            Array.isArray(rows) ? rows : [],
            useExternalScope ? scopeSchoolId : '',
            useExternalScope ? scopeCatalogType : undefined
        );
    }, [useExternalScope, scopeSchoolId]);

    const fetchFilteredActivities = useCallback(() => {
        const { listId, role } = buildListSchoolRequest(
            userDetails,
            useExternalScope ? scopeSchoolId : resolveSchoolId(userDetails)
        );
        if (!listId) return;

        if (serverPaginated) {
            const listBody = buildCatalogListBody(listId, {
                classId: effectiveClassFilter || '',
                catalogType: scopeCatalogType,
                superActivityId: filterSuperActivity || undefined,
            });
            ActivityTabelService.getAllActivityTabel(listId, role, listBody, {
                page: pg,
                limit: rpg,
                search: debouncedSearch,
            })
                .then((res) => {
                    const { rows, total } = parseCatalogListResponse(res);
                    setTabelList(rows);
                    setTempActivityList(rows);
                    setListTotal(total);
                })
                .catch(() => {});
            return;
        }

        const hasClass = Boolean(effectiveClassFilter);
        const hasArea = Boolean(filterSuperActivity);

        const finalizeRows = (res) => {
            let rows = applySchoolScopedRows(res);
            if (useExternalScope) rows = filterRowsByCatalogType(rows, scopeCatalogType);
            if (hasClass) rows = filterRowsByClassId(rows, effectiveClassFilter);
            if (hasArea) rows = filterRowsBySuperActivity(rows, filterSuperActivity);
            setTabelList(rows);
            setTempActivityList(rows);
        };

        const listBody = useExternalScope
            ? buildCatalogListBody(listId, {
                classId: effectiveClassFilter || '',
                catalogType: scopeCatalogType,
              })
            : {};

        if (!hasClass && !hasArea) {
            ActivityTabelService.getAllActivityTabel(listId, role, listBody)
                .then(finalizeRows)
                .catch(() => {});
            return;
        }

        if (!hasClass && hasArea) {
            ActivityTabelService.getAllActivityTabel(listId, role, listBody)
                .then(finalizeRows)
                .catch(() => {});
            return;
        }

        const reqBody = {
            ...buildCatalogListBody(listId, {
                classId: effectiveClassFilter || '',
                catalogType: useExternalScope ? scopeCatalogType : undefined,
            }),
            ...(hasArea ? { superActivityId: filterSuperActivity } : {}),
        };

        ActivityTabelService.getAllActivityTabeBySuperActivityId(reqBody)
            .then(finalizeRows)
            .catch(() => {
                ActivityTabelService.getAllActivityTabel(listId, role, listBody)
                    .then(finalizeRows)
                    .catch(() => {});
            });
    }, [
        effectiveClassFilter,
        filterSuperActivity,
        userDetails,
        useExternalScope,
        scopeSchoolId,
        scopeCatalogType,
        applySchoolScopedRows,
        serverPaginated,
        pg,
        rpg,
        debouncedSearch,
    ]);

    useEffect(() => {
        loadSuperActivitiesForClass(effectiveClassFilter || null);
    }, [effectiveClassFilter, scopeSchoolId, loadSuperActivitiesForClass]);

    useEffect(() => {
        fetchFilteredActivities();
    }, [fetchFilteredActivities]);

    useEffect(() => {
        if (sharedSchoolList) {
            setAddSchoolList(sharedSchoolList);
        }
    }, [sharedSchoolList]);

    useEffect(() => {
        if (sharedClassList) {
            setAddClassList(sharedClassList);
            return;
        }
        getAddClassList();
        return () => {
            setTabelIdList([]);
            setSuperActivityList([]);
            setTabelList([]);
            setAddSuperActivityList([]);
            setAddClassList([]);
        }
    }, [sharedClassList, scopeSchoolId, useExternalScope]);
    const filterSuperActivitys = (event)=>{

        setfilterSuperActivity(event.target.value);
        if(event.target.value){
        
            // const filterValue = temActivitylList.filter(act=>act.superActivityId._id === event.target.value);
            // setActivityList(filterValue);
            const setValues = temActivitylList.map(result=>{
                return {name:result.ActivityName,value:result._id};
            });
            setExerciseList(setValues);
           
        }else{
            setActivityList(temActivitylList);
            const setValues = temActivitylList.map(result=>{
                return {name:result.activityName,value:result._id};
            });
            setExerciseList(setValues);
        }
    
        }
        const filterExcDetails = (event) => {
        const extId = event?event._id:'';
            setExercise(extId);
            if (extId) {
                const filterValue = temActivitylList.filter(act => act._id === extId);
                setTabelList(filterValue);
            } else {
                setTabelList(temActivitylList);
            }
    
        }
 
        const getSuperActivityList = (event) => {
            loadSuperActivitiesForClass(event.target.value);
        }
    const getActivityTabelList = () => {
        fetchFilteredActivities();
    }
    const checkExerciseContent = useCallback(async (activityId) => {
        if (!activityId) {
            setExerciseHasContent(false);
            return false;
        }
        try {
            const rows = await SubActivityService.getAllSubActivityByActivityId({ activityId });
            const blocked = (Array.isArray(rows) ? rows : []).some((row) => hasCatalogContent(row));
            setExerciseHasContent(blocked);
            return blocked;
        } catch {
            setExerciseHasContent(false);
            return false;
        }
    }, []);

    const handleOpen = (status) => {
        if(status){
            const nextClassId = useExternalScope ? (scopeClassId || '') : '';
            setExerciseHasContent(false);
            setTabel({
            classId: nextClassId,
            superActivityId: '',
            activityName: '',
            notes: '',
            imageURL: [],
            videoURL: [],
            schooleId: isSuperAdminScope
                ? (scopeSchoolId || '')
                : resolveSchoolIdForClass(
                    addClassList,
                    nextClassId,
                    useExternalScope ? scopeSchoolId : '',
                    userDetails
                ),
            catalogType: scopeCatalogType,
        })
        }
     
          setOpen(true);
      };
    const onclick = () => {
        setOpen(true);
    }
    const handleClose = () => {
        setOpen(false);
        setExerciseHasContent(false);
        setMediaUploading(false);
        setMediaUploadProgress({ percent: 0, message: '' });
    };
    const handleChange = (event) => {
        setAge(event.target.value);
    };
    const onSubmit = data => {
        console.log(JSON.stringify(data, null, 2));
    };

    const getAddClassList = () => {
        const { listId, role } = buildListSchoolRequest(
            userDetails,
            useExternalScope ? scopeSchoolId : resolveSchoolId(userDetails)
        );
        if (!listId) return;

        AddClassService.getAllAddClass(listId, role).then((res) => {
            setAddClassList(res);
            if (!useExternalScope && res.length > 0) {
                setFilterClassId(res[0]._id);
            }
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getClassNameList = (event) => {
        AddClassService.getAddClassNameById({ className: event.target.value }).then((res) => {

            setClassNameList(res);

        }).catch((err) => {
            setError(err.message);
        });
    }
    const editActivityTabel = (tabel) => {
        const obj = JSON.parse(JSON.stringify(tabel));

        obj.superActivityId = tabel.superActivityId ? tabel.superActivityId._id : '';
        obj.classId = tabel.classId ? tabel.classId._id :'';
        obj.notes = tabel.notes || '';
        obj.imageURL = Array.isArray(tabel.imageURL) ? tabel.imageURL.filter(Boolean) : [];
        obj.videoURL = Array.isArray(tabel.videoURL) ? tabel.videoURL.filter(Boolean) : [];
        checkExerciseContent(obj._id || tabel._id);
        obj.schooleId = isSuperAdminScope
            ? resolveCatalogFormSchooleId(tabel)
            : (resolveRowSchoolId(tabel) || resolveSchoolIdForClass(
                addClassList,
                obj.classId,
                useExternalScope ? scopeSchoolId : '',
                userDetails
            ));
        obj.catalogType = tabel.catalogType || 'indian';
        getSuperActivityList({target:{value:obj.classId}}) 
        //  tabel.superActivityId = tabel.superActivityId ? tabel.superActivityId._id :''; 
        setTabel(obj)
        handleOpen(false)
    }
    const addActivityFromRow = (row) => {
        const nextClassId = row.classId ? (row.classId._id || row.classId) : '';
        const nextSuperActivityId = row.superActivityId
            ? (row.superActivityId._id || row.superActivityId)
            : '';
        if (nextClassId) {
            getSuperActivityList({ target: { value: nextClassId } });
        }
        setTabel({
            classId: nextClassId,
            superActivityId: nextSuperActivityId,
            activityName: '',
            notes: '',
            imageURL: [],
            videoURL: [],
            schooleId: isSuperAdminScope
                ? resolveCatalogFormSchooleId(row)
                : (resolveRowSchoolId(row) || resolveSchoolIdForClass(
                    addClassList,
                    nextClassId,
                    useExternalScope ? scopeSchoolId : '',
                    userDetails
                )),
            catalogType: row.catalogType || scopeCatalogType,
        });
        setOpen(true);
    };
    const openView = (row) => {
        setViewRow(row || null);
        setViewOpen(true);
    };
    const closeView = () => {
        setViewOpen(false);
        setViewRow(null);
    };
    const deleteActivityTabel = (tabeldelete) => {
        if (!tabeldelete) return;
        setPendingDelete(tabeldelete);
        setDeleteConfirmOpen(true);
    };

    // Tabs are kept mounted (hidden) after first visit. Refresh area/activity
    // lists when this tab becomes active again so areas added on tab 1 appear
    // without a full page reload.
    useEffect(() => {
        if (!active) {
            setOpen(false);
            closeView();
            setDeleteConfirmOpen(false);
            setPendingDelete(null);
            return;
        }
        loadSuperActivitiesForClass(effectiveClassFilter || null);
        fetchFilteredActivities();
    }, [active]); // eslint-disable-line react-hooks/exhaustive-deps -- refresh only on tab activate

    const confirmDelete = async () => {
        const row = pendingDelete;
        setDeleteConfirmOpen(false);
        setPendingDelete(null);
        if (!row) return;
        try {
            await ActivityTabelService.deleteActivityTabel(row);
            getActivityTabelList();
        } catch {
            // ignore
        }
    };
    const formik = useFormik({
        initialValues: tabel,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: async (values, { resetForm }) => {
            if (mediaUploading) {
                alert('Please wait for media upload to finish.');
                return;
            }
            if (isSuperAdminScope) {
                values.schooleId = resolveCatalogWriteSchooleId(true, values.schooleId);
            } else {
                values.schooleId = values.schooleId || resolveSchoolIdForClass(
                    addClassList,
                    values.classId,
                    useExternalScope ? scopeSchoolId : '',
                    userDetails
                ) || effectiveSchoolIdForWrite(userDetails, useExternalScope ? scopeSchoolId : '');
                if (!values.schooleId) {
                    alert('Please select a school in the scope filters before adding an activity.');
                    return;
                }
            }
            values.imageURL = Array.isArray(values.imageURL) ? values.imageURL.filter(Boolean) : [];
            values.videoURL = Array.isArray(values.videoURL) ? values.videoURL.filter(Boolean) : [];
            if (tabel._id && hasCatalogContent(values)) {
                const blocked = await checkExerciseContent(tabel._id);
                if (blocked) {
                    alert(CONTENT_EXCLUSIVE_HINT + ' Clear them on Exercises first.');
                    return;
                }
            }
            if (tabel._id) {
                ActivityTabelService.upadeActivityTabel(values).then((res) => {
                    handleClose();
                    getActivityTabelList();
                    // getSuperActivityList()
                    resetForm()
                    alert("Activity Tabel Updated Successfully.");
                }).catch((err) => {
                    alert(err?.response?.data?.message || err?.message || 'Update failed');
                });
            }
            else {
                ActivityTabelService.creteActivityTabel(values).then((res) => {
                    getActivityTabelList();
                    resetForm();
                    handleClose();
                    alert(" Activity Tabel Added Successfully.");
                    // props.history.push('/app/vendor');
                })
                    .catch((err) => {
                        alert(err?.response?.data?.message || err?.message || 'Add failed');
                    })
            }

        },
    });

    const resolveUploadSchooleId = () => {
        if (userDetails?.role === 'SUPERADMIN') {
            return (
                formik.values.schooleId
                || scopeSchoolId
                || resolveSchoolIdForClass(
                    addClassList,
                    formik.values.classId,
                    scopeSchoolId || '',
                    userDetails
                )
                || ''
            );
        }
        return (
            formik.values.schooleId
            || resolveSchoolIdForClass(
                addClassList,
                formik.values.classId,
                useExternalScope ? scopeSchoolId : '',
                userDetails
            )
            || resolveSchoolId(userDetails)
            || ''
        );
    };

    const uploadActivityMedia = async (files, type) => {
        if (exerciseHasContent) {
            alert(CONTENT_EXCLUSIVE_HINT + ' Clear them on Exercises first.');
            return;
        }
        const isVideo = type === 'videos';
        const fieldName = isVideo ? 'videos' : 'images';
        const urlField = isVideo ? 'videoURL' : 'imageURL';
        const maxCount = isVideo ? MAX_ACTIVITY_VIDEOS : MAX_ACTIVITY_IMAGES;
        const current = Array.isArray(formik.values[urlField]) ? formik.values[urlField] : [];

        if (!files.length) return;
        if (current.length + files.length > maxCount) {
            alert(`You can attach at most ${maxCount} ${isVideo ? 'videos' : 'images'}.`);
            return;
        }
        if (isVideo) {
            const oversized = files.filter((f) => f.size > MAX_VIDEO_BYTES);
            if (oversized.length) {
                alert(`Each video must be ${MAX_VIDEO_SIZE_MB} MB or smaller.`);
                return;
            }
        }

        // School is optional for SUPERADMIN (global catalog). Only send when selected.
        const schooleId = resolveUploadSchooleId();

        const formData = new FormData();
        files.forEach((file) => formData.append(fieldName, file));
        if (userDetails?.role === 'SUPERADMIN' && schooleId) {
            formData.append('schooleId', schooleId);
        }

        setMediaUploading(true);
        setMediaUploadProgress({ percent: 0, message: 'Sending files to server…' });
        try {
            const result = await ImagesStoreService.uploadMedia(formData, (prog) => {
                setMediaUploadProgress({
                    percent: prog.percent || 0,
                    message: `Uploading: ${prog.percent || 0}%`,
                });
            });
            const newUrls = isVideo ? (result.videoUrls || []) : (result.imageUrls || []);
            if (!newUrls.length) {
                throw new Error(result.message || 'Upload did not return any URLs.');
            }
            formik.setFieldValue(urlField, [...current, ...newUrls]);
        } catch (err) {
            alert(err?.response?.data?.message || err?.message || 'Upload failed');
        } finally {
            setMediaUploading(false);
            setMediaUploadProgress({ percent: 0, message: '' });
        }
    };

    const handleImagePick = (e) => {
        const files = Array.from(e.target.files || []);
        if (imageInputRef.current) imageInputRef.current.value = '';
        uploadActivityMedia(files, 'images');
    };

    const handleVideoPick = (e) => {
        const files = Array.from(e.target.files || []);
        if (videoInputRef.current) videoInputRef.current.value = '';
        uploadActivityMedia(files, 'videos');
    };

    const removeImageAt = (index) => {
        const current = Array.isArray(formik.values.imageURL) ? formik.values.imageURL : [];
        const url = current[index];
        formik.setFieldValue('imageURL', current.filter((_, i) => i !== index));
        if (url) {
            ImagesStoreService.deleteAzureImage({ imageURL: url }).catch(() => {});
        }
    };

    const removeVideoAt = (index) => {
        const current = Array.isArray(formik.values.videoURL) ? formik.values.videoURL : [];
        const url = current[index];
        formik.setFieldValue('videoURL', current.filter((_, i) => i !== index));
        if (url) {
            ImagesStoreService.deleteAzureImage({ imageURL: url }).catch(() => {});
        }
    };

    const emptyActivityMessage = useMemo(() => {
        const selectedClass = addClassList.find((c) => String(c._id) === String(effectiveClassFilter));
        const classLabel = selectedClass?.className || 'this class';
        const selectedArea = addSuperActivityList.find(
            (area) => String(area._id) === String(filterSuperActivity)
        );

        if (filterSuperActivity && selectedArea) {
            return `No list activities yet for "${selectedArea.superActivityName}" in ${classLabel}. Areas of work are added on the Area Of Work tab. Use Add Activity or the + button in Add More to add activities here.`;
        }
        if (effectiveClassFilter) {
            return `No list activities found for ${classLabel}. Select an area of work or use Add Activity to create one.`;
        }
        return 'No list activities found.';
    }, [effectiveClassFilter, filterSuperActivity, addClassList, addSuperActivityList]);

    const tableRows = useMemo(() => {
        if (serverPaginated) return tabelList;
        if (tabelList.length > 0) return tabelList;
        if (!filterSuperActivity) return [];
        if (!effectiveClassFilter) return [];

        const selectedClass = addClassList.find((c) => String(c._id) === String(effectiveClassFilter));
        const selectedArea = addSuperActivityList.find(
            (area) => String(area._id) === String(filterSuperActivity)
        );
        if (!selectedArea) return [];

        return [{
            _id: `placeholder-${filterSuperActivity}`,
            isPlaceholder: true,
            classId: selectedClass
                ? { _id: effectiveClassFilter, className: selectedClass.className }
                : { _id: effectiveClassFilter, className: '' },
            superActivityId: selectedArea,
            activityName: '',
        }];
    }, [tabelList, effectiveClassFilter, filterSuperActivity, addClassList, addSuperActivityList, serverPaginated]);

    const filteredTableRows = useMemo(() => {
        if (serverPaginated) return tableRows;
        const term = searchTerm.trim().toLowerCase();
        if (!term) return tableRows;
        return tableRows.filter((row) => {
            const cls = (row.classId?.className || '').toLowerCase();
            const area = (row.superActivityId?.superActivityName || '').toLowerCase();
            const name = (row.activityName || '').toLowerCase();
            return cls.includes(term) || area.includes(term) || name.includes(term);
        });
    }, [tableRows, searchTerm, serverPaginated]);

    const paginatedTableRows = serverPaginated
        ? filteredTableRows
        : filteredTableRows.slice(pg * rpg, pg * rpg + rpg);
    const paginationCount = serverPaginated ? listTotal : filteredTableRows.length;

    const hasActiveFilters = Boolean(effectiveClassFilter || filterSuperActivity);
    const showSchoolColumn = shouldShowSchoolColumn(embedded, scope);
    const displayHeaders = useMemo(
        () => (showSchoolColumn ? ['School', ...tableHeaders] : tableHeaders),
        [showSchoolColumn]
    );

    const renderSchoolCell = (row) => {
        if (!isSchoolAddedRow(row)) {
            return <Typography variant="caption" style={{ color: '#9aa6b6' }}>Default</Typography>;
        }
        const label = resolveRowSchoolLabel(row, addClassList, addSchoolList);
        return label ? (
            <Chip size="small" icon={<SchoolIcon style={{ fontSize: 14 }} />} label={label} className={classes.classChip} />
        ) : (
            <Typography variant="caption" style={{ color: '#9aa6b6' }}>—</Typography>
        );
    };

    const renderActivityFilters = () => (
        <Grid container spacing={2}>
            {!useExternalScope && (
            <Grid item xs={12} sm={6}>
                <span className={classes.fieldLabel}>Class</span>
                <FormControl variant="outlined" size="small" fullWidth>
                    <Select
                        displayEmpty
                        value={filterClassId}
                        onChange={(e) => {
                            setfilterSuperActivity('');
                            setFilterClassId(e.target.value);
                        }}
                    >
                        <MenuItem value=""><em>All Classes</em></MenuItem>
                        {addClassList.map(({ _id, className }) => (
                            <MenuItem key={_id} value={_id}>{className}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            )}
            <Grid item xs={12} sm={useExternalScope ? 12 : 6}>
                <span className={classes.fieldLabel}>Area Of Work</span>
                <FormControl variant="outlined" size="small" fullWidth>
                    <Select
                        displayEmpty
                        id="superActivityName"
                        name="superActivityId"
                        value={filterSuperActivity}
                        onChange={(e) => {
                            setfilterSuperActivity(e.target.value);
                            setpg(0);
                        }}
                    >
                        <MenuItem value=""><em>All Areas Of Work</em></MenuItem>
                        {addSuperActivityList.map(({ _id, superActivityName }) => (
                            <MenuItem key={_id} value={_id}>{superActivityName}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    );

    const renderActivityTableRow = (tabel) => (
        <TableRow key={tabel._id} hover>
            {showSchoolColumn && <TableCell>{renderSchoolCell(tabel)}</TableCell>}
            <TableCell>
                {tabel.classId?.className ? (
                    <Chip size="small" icon={<SchoolIcon style={{ fontSize: 14 }} />} label={tabel.classId.className} className={classes.classChip} />
                ) : '—'}
            </TableCell>
            <TableCell>
                {tabel.superActivityId?.superActivityName ? (
                    <Chip size="small" label={tabel.superActivityId.superActivityName} className={classes.areaChip} />
                ) : '—'}
            </TableCell>
            <TableCell>
                {tabel.isPlaceholder ? (
                    <span className={classes.placeholderText}>No activities yet</span>
                ) : tabel.activityName ? (
                    <Chip size="small" label={tabel.activityName} className={classes.nameChip} />
                ) : '—'}
            </TableCell>
            <TableCell align="center">
                <Tooltip title="Add another activity in this area of work">
                    <IconButton className={classes.iconAction} size="small" onClick={() => addActivityFromRow(tabel)}>
                        <AddIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
            </TableCell>
            <TableCell>
                <Box display="flex" alignItems="center">
                    {!tabel.isPlaceholder && (
                        <Tooltip title="View">
                            <IconButton className={classes.viewIcon} size="small" onClick={() => openView(tabel)}>
                                <VisibilityIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    )}
                    {!tabel.isPlaceholder && (
                        canEditDeleteActivityRow(tabel) ? (
                            <>
                                <Tooltip title="Edit">
                                    <IconButton className={classes.iconAction} size="small" onClick={() => editActivityTabel(tabel)}>
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Delete">
                                    <IconButton className={classes.deleteIcon} size="small" onClick={() => deleteActivityTabel(tabel)}>
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </>
                        ) : (
                            <>
                                <EditIcon className={classes.disabledIcon} fontSize="small" title="System activities cannot be edited" />
                                <DeleteIcon className={classes.disabledIcon} fontSize="small" title="System activities cannot be deleted" />
                            </>
                        )
                    )}
                </Box>
            </TableCell>
        </TableRow>
    );

    const renderActivityTable = () => (
        <>
            <TableContainer component={Paper} elevation={0} style={{ maxHeight: embedded ? 560 : 520 }}>
                <Table stickyHeader size="small" className="dashboard-table-row-hover">
                    <TableHead>
                        <TableRow>
                            {displayHeaders.map((key) => (
                                <TableCell key={key} className={classes.headCell}>{key}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {paginatedTableRows.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={displayHeaders.length} align="center" style={{ padding: 48, color: '#7a8aa0' }}>
                                    <Typography variant="body2">
                                        {hasActiveFilters ? emptyActivityMessage : 'No list activities found.'}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            paginatedTableRows.map(renderActivityTableRow)
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                component="div"
                rowsPerPageOptions={[10, 25, 50, 100]}
                count={paginationCount}
                page={pg}
                onPageChange={handleChangePage}
                rowsPerPage={rpg}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </>
    );

    const pageContent = (
        <>
            {!embedded && (
            <PageTitle title="List Of Activities" button={<Button
                variant="contained" onClick={() => handleOpen(true)}
                size="medium"
                color="secondary" style={{ backgroundColor: 'rgb(15 59 98)' }}> Add Activity
            </Button>} />
            )}
            {!embedded && (
            <Box style={{ marginBottom: 16, marginTop: 8, padding: 12, backgroundColor: 'rgba(0,0,0,0.04)', borderRadius: 4 }}>
                <Typography variant="body2" color="textSecondary">
                    By default, all area of work, activities, and exercise are added. If you want to add extra activities, add them here.
                </Typography>
            </Box>
            )}
            {embedded ? (
                <>
                    <Card elevation={0} className={classes.embeddedFiltersCard}>
                        <Box className={classes.filtersHeader}>
                            <Box display="flex" alignItems="center" gridGap={8}>
                                <FilterListIcon style={{ fontSize: 18, color: '#1769d6' }} />
                                <Typography style={{ fontWeight: 700, color: '#0f2d4d', fontSize: '0.9rem' }}>
                                    List Of Activities
                                </Typography>
                            </Box>
                        </Box>
                        <Box className={classes.filtersBody}>
                            {renderActivityFilters()}
                            {hasActiveFilters && tabelList.length === 0 && tableRows.length === 0 && (
                                <Box className={classes.emptyFilterBox}>
                                    <Typography className={classes.emptyFilterText}>{emptyActivityMessage}</Typography>
                                </Box>
                            )}
                        </Box>
                    </Card>
                    <Card elevation={0} className={classes.embeddedTableCard}>
                        <Box className={classes.toolbar}>
                            <Typography style={{ fontWeight: 700, color: '#0f2d4d' }}>
                                {paginationCount} Activit{paginationCount === 1 ? 'y' : 'ies'}
                            </Typography>
                            <Box display="flex" alignItems="center" gridGap={10}>
                                <Button variant="contained" className={classes.primaryBtn} size="small" startIcon={<AddIcon />} onClick={() => handleOpen(true)}>
                                    Add Activity
                                </Button>
                                <TextField
                                    size="small"
                                    variant="outlined"
                                    placeholder="Search…"
                                    value={searchTerm}
                                    onChange={(e) => { setSearchTerm(e.target.value); setpg(0); }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon style={{ fontSize: 18, color: '#9aa6b6' }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <Tooltip title="Refresh">
                                    <IconButton className={classes.iconBtnOutlined} size="small" onClick={fetchFilteredActivities}>
                                        <RefreshIcon style={{ fontSize: 20, color: '#46566b' }} />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </Box>
                        {renderActivityTable()}
                    </Card>
                </>
            ) : (
            <>
             <Card sx={{ maxWidth: 345 }}>
                <Box style={{margin:"15px"}}  >
            <Grid container spacing={2}>
                {!useExternalScope && (
                <Grid item xs={12} sm={6}>
                    <span className={classes.fieldLabel}>Class</span>
                    <FormControl variant="outlined" size="small" fullWidth>
                        <Select
                            displayEmpty
                            value={filterClassId}
                            onChange={(e) => {
                                setfilterSuperActivity('');
                                setFilterClassId(e.target.value);
                            }}
                        >
                            <MenuItem value=""><em>All Classes</em></MenuItem>
                            {addClassList.map(({ _id, className }) => (
                                <MenuItem key={_id} value={_id}>{className}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                )}
                <Grid item xs={12} sm={useExternalScope ? 12 : 6}>
                    <span className={classes.fieldLabel}>Area Of Work</span>
                    <FormControl variant="outlined" size="small" fullWidth>
                        <Select
                            displayEmpty
                            id="superActivityName"
                            name="superActivityId"
                            value={filterSuperActivity}
                            onChange={(e) => {
                                setfilterSuperActivity(e.target.value);
                                setpg(0);
                            }}
                        >
                            <MenuItem value=""><em>All Areas Of Work</em></MenuItem>
                            {addSuperActivityList.map(({ _id, superActivityName }) => (
                                <MenuItem key={_id} value={_id}>{superActivityName}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>

            {hasActiveFilters && tabelList.length === 0 && tableRows.length === 0 && (
                <Box className={classes.emptyFilterBox}>
                    <Typography className={classes.emptyFilterText}>
                        {emptyActivityMessage}
                    </Typography>
                </Box>
            )}

            </Box>
            </Card >
            <br></br>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                        <TableContainer component={Paper} elevation={0} style={{ maxHeight: 520 }}>
                        
                        <Table stickyHeader size="small" className="dashboard-table-row-hover">
                            <TableHead >
                                <TableRow>
                                    {displayHeaders.map(key => (
                                        <TableCell key={key} className={classes.headCell}>{key}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {paginatedTableRows.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={displayHeaders.length} align="center" style={{ padding: 48, color: '#7a8aa0' }}>
                                            <Typography variant="body2">
                                                {hasActiveFilters ? emptyActivityMessage : 'No list activities found.'}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    paginatedTableRows.map(renderActivityTableRow)
                                )}
                            </TableBody>
                        </Table>
                        </TableContainer>
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[10, 25, 50, 100]}
                            count={paginationCount}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>
            </>
            )}
            <Dialog open={open} onClose={handleClose} scroll="paper" PaperProps={{ className: classes.dialogPaper }}>
                <Box className={classes.dialogTitleBar}>
                    <span className={classes.dialogTitleText}>
                        {tabel._id ? 'Edit Activity' : 'Add Activity'}
                    </span>
                    <IconButton size="small" onClick={handleClose}>
                        <CloseIcon style={{ fontSize: 20, color: '#7a8aa0' }} />
                    </IconButton>
                </Box>
                <form onSubmit={formik.handleSubmit}>
                    <DialogContent className={classes.dialogBody}>
                        <Grid container spacing={2}>
                            {isSuperAdminScope && (
                                <Grid item xs={12}>
                                    <span className={classes.fieldLabel}>School</span>
                                    <FormControl variant="outlined" size="small" fullWidth>
                                        <Select
                                            displayEmpty
                                            name="schooleId"
                                            value={formik.values.schooleId || ''}
                                            onChange={(e) => formik.setFieldValue('schooleId', e.target.value)}
                                            renderValue={(selected) => {
                                                if (!selected) {
                                                    return <em style={{ color: '#8a97a8' }}>All Schools (Default)</em>;
                                                }
                                                const match = addSchoolList.find(
                                                    (s) => normalizeId(s._id) === String(selected)
                                                );
                                                return match ? resolveSchoolLabel(match) : String(selected);
                                            }}
                                        >
                                            <MenuItem value=""><em>All Schools (Default)</em></MenuItem>
                                            {addSchoolList.map((s) => (
                                                <MenuItem key={s._id} value={s._id}>{resolveSchoolLabel(s)}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            )}
                            <Grid item xs={12} >
                                <span className={classes.fieldLabel}>Class</span>
                                <FormControl
                                    variant="outlined" size="small" fullWidth
                                    error={formik.touched.classId && Boolean(formik.errors.classId)}
                                >
                                    <Select
                                        id="demo-simple-select"
                                        name="classId"
                                        displayEmpty
                                        value={formik.values.classId}
                                        onChange={e => {
                                            formik.handleChange(e);
                                            getSuperActivityList(e);
                                            // When SUPERADMIN has an explicit School field, don't let a
                                            // Class change silently override that choice.
                                            if (isSuperAdminScope) return;
                                            const sid = resolveSchoolIdForClass(
                                                addClassList,
                                                e.target.value,
                                                useExternalScope ? scopeSchoolId : '',
                                                userDetails
                                            );
                                            if (sid) formik.setFieldValue('schooleId', sid);
                                        }}
                                    >
                                        <MenuItem value=""><em>Select Class</em></MenuItem>
                                        {addClassList.map(({ _id, className }) => (
                                            <MenuItem key={_id} value={_id}>{className}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} >
                                <span className={classes.fieldLabel}>Area Of Work</span>
                                <FormControl
                                    variant="outlined" size="small" fullWidth
                                    error={formik.touched.superActivityId && Boolean(formik.errors.superActivityId)}
                                >
                                    <Select
                                        id="superActivityName"
                                        name="superActivityId"
                                        displayEmpty
                                        onChange={formik.handleChange}
                                        value={formik.values.superActivityId}
                                    >
                                        <MenuItem value=""><em>Select Area Of Work</em></MenuItem>
                                        {addSuperActivityList.map(({ _id, superActivityName }) => (
                                            <MenuItem key={_id} value={_id}>{superActivityName}</MenuItem>
                                        ))}
                                    </Select>
                                    {formik.touched.superActivityId && formik.errors.superActivityId && (
                                        <FormHelperText>{formik.errors.superActivityId}</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <span className={classes.fieldLabel}>List Of Activities</span>
                                <TextField
                                    fullWidth size="small" variant="outlined"
                                    autoFocus
                                    id="activityName"
                                    name="activityName"
                                    type="text"
                                    value={formik.values.activityName}
                                    onChange={formik.handleChange}
                                    error={formik.touched.activityName && Boolean(formik.errors.activityName)}
                                    helperText={formik.touched.activityName && formik.errors.activityName}
                                />
                            </Grid>
                            {exerciseHasContent && (
                                <Grid item xs={12}>
                                    <Box className={classes.exclusiveWarnBox}>
                                        <Typography className={classes.exclusiveWarnText}>
                                            {CONTENT_EXCLUSIVE_HINT} An exercise under this activity already has notes or media — clear them on Exercises to add here.
                                        </Typography>
                                    </Box>
                                </Grid>
                            )}
                            <Grid item xs={12}>
                                <span className={classes.fieldLabel}>Notes</span>
                                <TextField
                                    fullWidth size="small" variant="outlined"
                                    id="notes"
                                    name="notes"
                                    multiline
                                    minRows={3}
                                    maxRows={8}
                                    disabled={exerciseHasContent}
                                    value={formik.values.notes || ''}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <span className={classes.fieldLabel}>Images &amp; Videos</span>
                                <Typography className={classes.mediaHint}>
                                    Upload up to {MAX_ACTIVITY_IMAGES} images and {MAX_ACTIVITY_VIDEOS} videos
                                    (max {MAX_VIDEO_SIZE_MB} MB each). Uses the existing media upload API.
                                </Typography>
                                <input
                                    ref={imageInputRef}
                                    type="file"
                                    accept="image/*"
                                    multiple
                                    hidden
                                    onChange={handleImagePick}
                                />
                                <input
                                    ref={videoInputRef}
                                    type="file"
                                    accept="video/*,.mp4,.webm,.mov,.m4v"
                                    multiple
                                    hidden
                                    onChange={handleVideoPick}
                                />
                                <Box className={classes.mediaActions}>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        className={classes.mediaPickBtn}
                                        startIcon={<ImageIcon />}
                                        disabled={mediaUploading || exerciseHasContent}
                                        onClick={() => imageInputRef.current && imageInputRef.current.click()}
                                    >
                                        Add Images
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        className={classes.mediaPickBtn}
                                        startIcon={<VideocamIcon />}
                                        disabled={mediaUploading || exerciseHasContent}
                                        onClick={() => videoInputRef.current && videoInputRef.current.click()}
                                    >
                                        Add Videos
                                    </Button>
                                    {mediaUploading && <CircularProgress size={20} style={{ color: '#1769d6' }} />}
                                </Box>
                                {mediaUploading && (
                                    <Box className={classes.uploadProgressWrap}>
                                        <Typography variant="caption" style={{ color: '#46566b' }}>
                                            {mediaUploadProgress.message || 'Uploading…'}
                                        </Typography>
                                        <LinearProgress
                                            variant="determinate"
                                            value={mediaUploadProgress.percent || 0}
                                            style={{ marginTop: 4, borderRadius: 4, height: 6 }}
                                        />
                                    </Box>
                                )}
                                {(formik.values.imageURL || []).length > 0 && (
                                    <>
                                        <Typography className={classes.fieldLabel} style={{ marginTop: 8 }}>
                                            Images ({formik.values.imageURL.length})
                                        </Typography>
                                        <Box className={classes.mediaPreviewGrid}>
                                            {formik.values.imageURL.map((url, index) => (
                                                <Box key={`img-${index}-${url}`} className={classes.mediaPreviewItem}>
                                                    <img src={url} alt={`Activity ${index + 1}`} className={classes.mediaThumb} />
                                                    <IconButton
                                                        size="small"
                                                        className={classes.mediaRemoveBtn}
                                                        disabled={mediaUploading || exerciseHasContent}
                                                        onClick={() => removeImageAt(index)}
                                                    >
                                                        <DeleteIcon style={{ fontSize: 16, color: '#b91c1c' }} />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                    </>
                                )}
                                {(formik.values.videoURL || []).length > 0 && (
                                    <>
                                        <Typography className={classes.fieldLabel} style={{ marginTop: 12 }}>
                                            Videos ({formik.values.videoURL.length})
                                        </Typography>
                                        <Box className={classes.mediaPreviewGrid}>
                                            {formik.values.videoURL.map((url, index) => (
                                                <Box key={`vid-${index}-${url}`} className={classes.mediaPreviewItem}>
                                                    <video
                                                        src={url}
                                                        className={classes.mediaThumb}
                                                        muted
                                                        preload="metadata"
                                                    />
                                                    <IconButton
                                                        size="small"
                                                        className={classes.mediaRemoveBtn}
                                                        disabled={mediaUploading || exerciseHasContent}
                                                        onClick={() => removeVideoAt(index)}
                                                    >
                                                        <DeleteIcon style={{ fontSize: 16, color: '#b91c1c' }} />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                    </>
                                )}
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className={classes.dialogFooter}>
                        <Button onClick={handleClose} className={classes.cancelBtn} disabled={mediaUploading}>Cancel</Button>
                        <Button type="submit" variant="contained" className={classes.saveBtn} disabled={mediaUploading}>
                            {mediaUploading ? 'Uploading…' : (tabel._id ? 'Update' : 'Add')}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>

            <Dialog open={viewOpen} onClose={closeView} fullWidth maxWidth="sm">
                <DialogTitle>Activity Details</DialogTitle>
                <DialogContent dividers>
                    <Typography variant="body2"><b>Class:</b> {viewRow?.classId?.className || ''}</Typography>
                    <Typography variant="body2"><b>Area Of Work:</b> {viewRow?.superActivityId?.superActivityName || ''}</Typography>
                    <Typography variant="body2"><b>Activity:</b> {viewRow?.activityName || ''}</Typography>
                    <Box mt={2}>
                        <Typography variant="body2" style={{ fontWeight: 900, marginBottom: 6 }}>Notes</Typography>
                        <Paper style={{ padding: 10, background: "#f8fafc", border: "1px solid #e5e7eb" }}>
                            <Typography variant="body2" style={{ whiteSpace: "pre-wrap" }}>
                                {viewRow?.notes ? String(viewRow.notes) : "—"}
                            </Typography>
                        </Paper>
                    </Box>
                    {(Array.isArray(viewRow?.imageURL) && viewRow.imageURL.filter(Boolean).length > 0) && (
                        <Box mt={2}>
                            <Typography variant="body2" style={{ fontWeight: 900, marginBottom: 6 }}>
                                Images ({viewRow.imageURL.filter(Boolean).length})
                            </Typography>
                            <Box display="flex" flexWrap="wrap" style={{ gap: 10 }}>
                                {viewRow.imageURL.filter(Boolean).map((url, index) => (
                                    <a key={`view-img-${index}`} href={url} target="_blank" rel="noopener noreferrer">
                                        <img
                                            src={url}
                                            alt={`Activity ${index + 1}`}
                                            style={{
                                                width: 96,
                                                height: 96,
                                                objectFit: 'cover',
                                                borderRadius: 8,
                                                border: '1px solid #e6eaf0',
                                            }}
                                        />
                                    </a>
                                ))}
                            </Box>
                        </Box>
                    )}
                    {(Array.isArray(viewRow?.videoURL) && viewRow.videoURL.filter(Boolean).length > 0) && (
                        <Box mt={2}>
                            <Typography variant="body2" style={{ fontWeight: 900, marginBottom: 6 }}>
                                Videos ({viewRow.videoURL.filter(Boolean).length})
                            </Typography>
                            <Box display="flex" flexDirection="column" style={{ gap: 10 }}>
                                {viewRow.videoURL.filter(Boolean).map((url, index) => (
                                    <video
                                        key={`view-vid-${index}`}
                                        src={url}
                                        controls
                                        style={{
                                            width: '100%',
                                            maxHeight: 240,
                                            borderRadius: 8,
                                            backgroundColor: '#0f2d4d',
                                        }}
                                    />
                                ))}
                            </Box>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeView} style={{ backgroundColor: "rgb(15 59 98)", color: "white" }} variant="contained">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={deleteConfirmOpen}
                onClose={() => {
                    setDeleteConfirmOpen(false);
                    setPendingDelete(null);
                }}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>localhost:3000 says</DialogTitle>
                <DialogContent dividers>
                    <Typography variant="body2">
                        Are you sure you want to delete{" "}
                        <b>"{pendingDelete?.activityName ? String(pendingDelete.activityName) : "this activity"}"</b>?
                        <br />
                        <br />
                        All related exercises under this activity will also be deleted. This action cannot be undone.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={confirmDelete}
                        style={{ backgroundColor: "rgb(15 59 98)", color: "white" }}
                        variant="contained"
                    >
                        OK
                    </Button>
                    <Button
                        onClick={() => {
                            setDeleteConfirmOpen(false);
                            setPendingDelete(null);
                        }}
                        style={{ backgroundColor: "#f3e5e5", color: "#0f3b62" }}
                        variant="contained"
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );

    return pageContent;
}

